import { LandingSubmitType } from "../../types/landingTypes";
import { AppState, DefaultProps } from "../../types/types";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useLandingContext } from "./LandingProvider";
import { loadSessionData } from "../../util/store";
import { useNavigate } from "react-router-dom";
import { Link } from '@mui/material';

interface SignupDankeProps extends DefaultProps {
    appState: AppState,
    landingSubmitType: LandingSubmitType,
}



const SignupDanke: React.FC<SignupDankeProps> = props => {

    const navigate = useNavigate();

    function goToEmailChange() {
        //const goToEmailChange = () => {
        // window.location.replace(data.generatedLink);
        let cid = loadSessionData("cid");
        navigate("/landing/emailauswahl?cid=" + cid, { replace: true });
    }

    const { vorname,
        nachname,
        emailchoosen } = useLandingContext();

    return (
        <Container maxWidth="lg" className="container" >
            <Grid container spacing={0} className="container" sx={{ marginTop: { xs: '1rem', sm: '1rem', md: '3rem', lg: '3rem' } }}>
                <Grid item xs={12} md={6} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>
                    <Typography variant='h1' sx={{ fontSize: { xs: '1.3rem', sm: '1.3rem', md: '2rem', lg: '2rem' } }}>Guten Tag {vorname != null ? vorname : ""} {nachname != null ? nachname : ""}, </Typography>
                    <p>
                        wir freuen uns, dass Sie sich Ihr Digitales Postfach einrichten.
                    </p>
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>
                    <h1>Ihre E-Mail-Adresse</h1>
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>

                    <Box className={"answer-element "}
                        sx={{
                            backgroundColor: 'inherit',
                            borderBottom: '1px solid',
                            borderBottomColor: '#ffffff',
                            borderLeft: '1px solid #ffffff42',
                            padding: '1rem',
                            background: props.appState?.customizing?.colors?.decentBackground || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            "&:nth-child(even)": {
                                background: props.appState?.customizing?.elements?.backgroundEven || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            "&:nth-child(odd)": {
                                background: props.appState?.customizing?.elements?.backgroundOdd || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            ...props.appState?.customizing?.elements?.styleOverrides ?? {},
                        }}>

                        <Typography sx={{}}>
                            Wir haben Ihre E-Mail-Adresse für das Digitale Postfach hinterlegt.

                        </Typography>
                        <br />

                        <Typography sx={{ fontWeight: "bold", marginRight: "4em" }}>{emailchoosen}</Typography>

                        <Link sx={{ display: 'flex-inline', float:'left' }} onClick={goToEmailChange}>
                            <Box sx={{ fontSize: "1.0rem", display: 'flex-inline' }}>ändern</Box>
                        </Link>




                    </Box>
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>

                    <Box className={"answer-element "}
                        sx={{
                            backgroundColor: 'inherit',
                            borderBottom: '1px solid',
                            borderBottomColor: '#ffffff',
                            borderLeft: '1px solid #ffffff42',
                            padding: '1rem',
                            background: props.appState?.customizing?.colors?.decentBackground || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            "&:nth-child(even)": {
                                background: props.appState?.customizing?.elements?.backgroundEven || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            "&:nth-child(odd)": {
                                background: props.appState?.customizing?.elements?.backgroundOdd || 'linear-gradient(170deg, rgb(255 255 255 / 15%) 0%, rgba(255,255,255,0) 100%)',
                            },
                            ...props.appState?.customizing?.elements?.styleOverrides ?? {},
                        }}>
                        <Typography sx={{ fontWeight: "bold", marginBottom: "1em" }}>Sie erhalten in Kürze Ihren Registrierungslink per E-Mail.</Typography>

                        Bitte verwenden Sie den in der E-Mail enthaltenen Link um den finalen Schritt der Registrierung durchzuführen. Dieses Fenster können Sie dann schließen


                    </Box>
                </Grid>


            </Grid>


        </Container>
    );

}

export default SignupDanke;